import Link from "next/link";
import {gql} from "@apollo/client";
import PropTypes from "prop-types";
import classNames from 'classnames';

import {getPrimaryCategory} from "@/lib/utils/helpers";
import {CARD_SIZE, EXCLUDED_TERMS} from "@/lib/utils/constants";

export default function TermLinks(
  {
    terms,
    termClickable = true,
    className,
    primaryOnly = false,
    variant = 'default'
  }
) {
  let edges = terms?.edges;

  if (!edges?.length) {
    return null;
  }

  if (primaryOnly) {
    edges = [getPrimaryCategory(terms?.edges)];
  }

  const isSmallVariant = variant === 'small';

  return (
    <div className={className}>
      {edges.map((term, key) => {
        if (EXCLUDED_TERMS.includes(term.node.slug)) return null;

        const commonProps = {
          className: classNames(
            'mr-2',
            {'mb-2': !primaryOnly},
            {'mom-pill': !isSmallVariant},
            {'mom-term': isSmallVariant},
          ),
        };

        return termClickable ? (
          <Link key={key} {...commonProps} href={term.node.uri}>
            {term.node.name.toUpperCase()}
          </Link>
        ) : (
          <span key={key} {...commonProps}>
            {term.node.name.toUpperCase()}
          </span>
        );
      })}
    </div>
  );
}

TermLinks.fragments = {
  keyCategory: 'PostToCategoryFragment',
  entryCategory: gql`
    fragment PostToCategoryFragment on PostToCategoryConnection {
      edges {
        isPrimary
        node {
          uri
          name
          slug
        }
      }
    }
  `,
  keyTag: 'PostToTagFragment',
  entryTag: gql`
    fragment PostToTagFragment on PostToTagConnection {
      edges {
        isPrimary
        node {
          uri
          name
          slug
        }
      }
    }
  `,
  keyVideo: 'VideoToSeriesFragment',
  entryVideo: gql`
    fragment VideoToSeriesFragment on VideoToVideoSeriesConnection {
      edges {
        isPrimary
        node {
          uri
          name
          slug
        }
      }
    }
  `,
  keyRootTag: 'RootQueryToTagConnectionFragment',
  entryRootTag: gql`
    fragment RootQueryToTagConnectionFragment on RootQueryToTagConnection {
      edges {
        node {
          uri
          name
          slug
        }
      }
    }
  `,
};

TermLinks.propTypes = {
  primaryOnly: PropTypes.bool,
  terms: PropTypes.object,
  variant: PropTypes.oneOf(CARD_SIZE),
};
